import { Box, Container, Grid, Typography, Link, styled, useTheme, useMediaQuery } from "@mui/material";

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "#f5f5f5",
  padding: "48px 0 24px",
  marginTop: "auto",
  [theme.breakpoints.down("md")]: {
    padding: "40px 0 20px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "32px 0 16px",
  },
}));

const FooterSection = styled(Box)(({ theme }) => ({
  marginBottom: "24px",
  "& h6": {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginBottom: "12px",
    },
  },
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: "#666",
  textDecoration: "none",
  fontSize: "14px",
  display: "block",
  marginBottom: "8px",
  "&:hover": {
    color: "#1976d2",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
    marginBottom: "6px",
  },
}));

const Copyright = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  color: "#666",
  fontSize: "14px",
  marginTop: "24px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    marginTop: "16px",
  },
}));

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <Grid container spacing={isMobile ? 2 : 4}>
          <Grid item xs={12} sm={6} md={3}>
            <FooterSection>
              <Typography variant="h6">About Us</Typography>
              <FooterLink href="/about">About IELTS Practice</FooterLink>
              <FooterLink href="/contact">Contact Us</FooterLink>
              <FooterLink href="/careers">Careers</FooterLink>
            </FooterSection>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FooterSection>
              <Typography variant="h6">Resources</Typography>
              <FooterLink href="/blog">Blog</FooterLink>
              <FooterLink href="/tutorials">Tutorials</FooterLink>
              <FooterLink href="/faq">FAQ</FooterLink>
            </FooterSection>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FooterSection>
              <Typography variant="h6">Legal</Typography>
              <FooterLink href="/terms">Terms of Service</FooterLink>
              <FooterLink href="/privacy">Privacy Policy</FooterLink>
              <FooterLink href="/cookies">Cookie Policy</FooterLink>
            </FooterSection>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FooterSection>
              <Typography variant="h6">Connect</Typography>
              <FooterLink href="https://facebook.com">Facebook</FooterLink>
              <FooterLink href="https://twitter.com">Twitter</FooterLink>
              <FooterLink href="https://linkedin.com">LinkedIn</FooterLink>
            </FooterSection>
          </Grid>
        </Grid>

        <Copyright>
          © {new Date().getFullYear()} IELTS Practice. All rights reserved.
        </Copyright>
      </Container>
    </FooterContainer>
  );
}

export default Footer;